import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { IconButton, Tooltip } from '@mui/material';

const IconActionTableRefuse = props => {
  const { handleActionApprove, stageState } = props;

  return (
    <Tooltip title="Rechazar">
      <IconButton aria-label="state" onClick={handleActionApprove}>
        {(stageState === 1 && (
          <CancelIcon style={{ color: 'red' }} fontSize="small" />
        )) ||
          (stageState === 2 && <CheckBoxOutlineBlankIcon fontSize="small" />)}
      </IconButton>
    </Tooltip>
  );
};

export default IconActionTableRefuse;
